import { SuccessModal } from '@/lib/Modals';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

type SupportSuccessModalProps = {
  onConfirm: () => Promise<void>;
  onClose: VoidFunction;
};

export const SupportSuccessModal: FC<SupportSuccessModalProps> = ({ onConfirm, onClose }) => {
  const { t } = useTranslation('ALL');

  return (
    <SuccessModal onConfirm={onConfirm} onClose={onClose}>
      <div>
        <h1 className='font-semibold text-primary-900'>{t('requestSubmitted')}</h1>
        <p className='text-sm text-tertiary-600'>{t('requestReceived')}</p>
      </div>
    </SuccessModal>
  );
};
